export const STYLES_MAP = {
    default: {
        top: {
            transform: 'scaleY(-1)',
            bottom: '-7px',
        },
        bottom: {
            top: '-7px',
        },
    },
    onboarding: {
        top: {
            transform: 'scaleY(-1)',
            bottom: '-14px',
        },
        bottom: {
            top: '-14px',
        },
    },
};

export const TOOLTIP_MARGIN = 8;

export const ARROW_SIZE = 24;

export const ARROW_X_BREAKPOINT = 9;

export const AUTO_OPEN_TIMEOUT = 500;
